import TransitionWrapper from "../../../components/common/transition-wrapper";

interface PackReserveButtonProps {
  quantity: number;
  userPrice: number | null | undefined;
  discountAmount: number;
  loading: boolean;
  onClick: () => void;
}

const PackReserveButton = ({
  quantity,
  userPrice,
  discountAmount,
  loading,
  onClick,
}: PackReserveButtonProps) => (
  <div className="w-full bg-white mt-auto relative z-50">
    <div className="absolute left-0 top-[-2.7rem] w-full h-[43px] bg-[#282828] rounded-tl-[10px] rounded-tr-[10px] text-white text-sm font-semibold flex justify-center items-center z-10">
      {loading ? (
        <span>...</span>
      ) : (
        <div>{discountAmount.toLocaleString()}원 할인받았어요!</div>
      )}
    </div>
    <div onClick={onClick} className="px-5 py-4 w-full relative z-0">
      <TransitionWrapper
        scale={0.95}
        opacity={0.8}
        className="w-full h-[60px] flex items-center justify-center bg-[#1562fc] rounded-lg border cursor-pointer"
      >
        <div className="text-center flex items-center space-x-1">
          <span className="text-white text-base font-semibold leading-snug">
            {quantity}개
          </span>
          <span className="text-white text-base font-bold leading-snug">
            {loading ? (
              <span>...</span>
            ) : userPrice ? (
              <div className="text-white text-base font-bold leading-snug">
                {(quantity * userPrice).toLocaleString()}
              </div>
            ) : (
              0
            )}
          </span>
          <span className="text-white text-base font-semibold leading-snug">
            원 예약하기
          </span>
        </div>
      </TransitionWrapper>
    </div>
  </div>
);

export default PackReserveButton;
